import { createContext, useContext } from 'react';
import { EasyClaimCustomerConfigurationDto } from 'src/easyclaim.api.client.typescript/src';

export interface CustomerConfigurationContextType {
	configuration: EasyClaimCustomerConfigurationDto | undefined;
}

const CustomerConfigurationContext = createContext<CustomerConfigurationContextType>({
	configuration: undefined,
});

export const useCustomerConfiguration = (): EasyClaimCustomerConfigurationDto | undefined => {
	const { configuration } = useContext(CustomerConfigurationContext);

	return configuration;
};

export const CustomerConfiguration = () => useContext(CustomerConfigurationContext).configuration;

export const CustomerConfigurationConsumer = CustomerConfigurationContext.Consumer;

export default CustomerConfigurationContext;
